module.exports = __webpack_public_path__ + "static/media/footer.d6bd563f.png";